module.exports = __webpack_public_path__ + "img/hpp-square.82b3fe92.png";